class CartRestoreNotification extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('#cart-restore-notification');
    this.closeButton = this.querySelector('#cart-restore-close');
    this.sessionKey = 'cart_restore_shown';

    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  connectedCallback() {
    if (!this.overlay || sessionStorage.getItem(this.sessionKey) === 'true') {
      return;
    }

    this.open();
    sessionStorage.setItem(this.sessionKey, 'true');

    this.closeButton.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) {
        this.close();
      }
    });

    document.addEventListener('keyup', this.handleKeyUp);
  }

  open() {
    this.overlay.style.display = 'flex';
  }

  close() {
    this.overlay.style.display = 'none';
    document.removeEventListener('keyup', this.handleKeyUp);
  }

  handleKeyUp(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

customElements.define('cart-restore-notification', CartRestoreNotification);
